import React from 'react';
import { Box, Typography } from '@mui/material';
import LoadingDial from '../components/loading/LoadingDial';

const Loading = ({ message }) => {
  return (
    <Box sx={{
      margin: 'auto',
      marginTop: '20vh',
      width: 'fit-content',
      color: '#808080',
      fontWeight: 500,
    }}>
      <LoadingDial />
      <Typography variant="body2" align="center">
        {message ? message : ''}
      </Typography>
    </Box>
  );
};

export default Loading;
